import { Box, Typography, IconButton, Hidden, LinearProgress } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useHistory } from 'react-router';
import { Formik } from 'formik';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { poaApprover, AddPoaApproverRequestBody } from '../../redux-store/types/api-types';
import { useDispatch } from 'react-redux';
import { CountryCodesDropDown } from '../commonComponents';
import {
  addPOAAppprover,
  updatePOAApprover,
  getPoaApproverById,
} from '../../redux-store/actions/userManagement';
import { AuthorisedSignatoryAndPOASchema } from '../../utils/schema';
import { Location } from 'history';
import { CommonFormForCompanyDistributors } from './addAuthorisedSignatory';
import { useEffect, useState } from 'react';
import { UserMgmtSuccessDialog } from './userMgmtListStyles';

export default function AddPOAApprover({
  location,
}: {
  location: Location<{ poaApproverId: number; distributorId: number }>;
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const { poaApproverId, distributorId: ID } = location.state || {};
  const [formikValues, setFormikValues] = useState<AddPoaApproverRequestBody | null>();

  const initialValues: AddPoaApproverRequestBody = {
    name: '',
    email: '',
    countryCode: '+91',
    countryNameAndCode: 'India: +91',
    phone: '',
    panNumber: '',
    pincode: '',
    buildingNo: '',
    streetName: '',
    city: '',
    state: '',
    country: '',
    distributorId: ID,
    amcId: '',
    isActive: true,
  };
  const [poaApproverDetails, setPoaApproverDetailsDetails] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [successDistributorId, setSuccessDistributorId] = useState<number | string | undefined>();

  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        setLoading(true);
        if (poaApproverId) {
          const getPoaApproverDetails = (await dispatch(
            getPoaApproverById(poaApproverId)
          )) as unknown as poaApprover;
          const {
            panNumber,
            pincode,
            buildingNo,
            streetName,
            city,
            state,
            country,
            distributorId,
            amcId,
            id,
            isActive,
          } = getPoaApproverDetails;
          const {
            firstName: name,
            phone,
            email,
            countryCode,
            countryNameAndCode,
          } = getPoaApproverDetails.user;
          setPoaApproverDetailsDetails({
            ...poaApproverDetails,
            name,
            panNumber,
            pincode,
            buildingNo,
            streetName,
            city,
            state,
            country,
            distributorId,
            amcId,
            id,
            phone,
            email,
            isActive,
            countryNameAndCode: countryNameAndCode ? countryNameAndCode : 'India: +91',
            countryCode: countryCode ? countryCode : '+91',
          });
        }
        if (!isComponentAlive) return;
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        if (isComponentAlive) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isComponentAlive = false;
    };
  }, []);

  // useEffect(() => {
  //   let isComponentActive = true;
  //   (async function () {
  //     try {
  //       if (!formikValues) return;
  //       if (poaApprover) {
  //         await dispatch(updatePOAApprover(id, formikValues));
  //       } else {
  //         await dispatch(addPOAAppprover({ ...formikValues, distributorId: ID }));
  //       }
  //       if (!isComponentActive) return;
  //       history.push('poa-approver', { distributorId: ID });
  //     } catch (e) {
  //       console.error((e as Error).message);
  //     }
  //   })();
  //   return () => {
  //     isComponentActive = false;
  //   };
  // }, [formikValues]);

  const onSubmit = async (values: AddPoaApproverRequestBody) => {
    try {
      if (poaApproverId) {
        await dispatch(
          updatePOAApprover(poaApproverId, {
            ...values,
            countryCode: values.countryNameAndCode?.split(':')[1].trim(),
          })
        );
        setSuccessDistributorId(values.distributorId);
        setSuccessMessage('POA Approver Details Updated Successfully!');
      } else {
        await dispatch(
          addPOAAppprover({
            ...values,
            countryCode: values.countryNameAndCode?.split(':')[1].trim(),
            distributorId: ID,
          })
        );
        setSuccessDistributorId(values.distributorId);
        setSuccessMessage('POA Approver Details Added Successfully!');
      }
    } catch (e) {
      console.error((e as Error).message);
    }
    //setFormikValues({ ...values, countryCode: values.countryNameAndCode?.split(':')[1].trim() });
  };

  return (
    <>
      <Formik
        initialValues={poaApproverDetails}
        onSubmit={onSubmit}
        enableReinitialize={true}
        validationSchema={AuthorisedSignatoryAndPOASchema}>
        {({ handleSubmit, values }) => (
          <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
              py: { xs: 2, sm: 5 },
              pl: { xs: 0, sm: 5 },
              mt: { xs: 2, sm: 5 },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            <Hidden smUp={true}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    poaApproverId
                      ? history.push('poa-approver-details', {
                          poaApproverId: values.id,
                          distributorId: values.distributorId,
                        })
                      : history.push('poa-approver', { distributorId: values.distributorId })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: '#1C2D47',
                  }}>
                  Back
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  my: 2,
                  py: 2,
                  pl: { xs: 3, sm: 0 },
                  color: 'primary.main',
                  bgcolor: 'rgba(238, 244, 251, 0.5)',
                }}>
                <PersonOutlineOutlinedIcon fontSize="large" />
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    pl: 1,
                  }}>
                  User Management
                </Typography>
              </Box>
            </Hidden>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Hidden only="xs">
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    poaApproverId
                      ? history.push('poa-approver-details', {
                          poaApproverId: values.id,
                          distributorId: values.distributorId,
                        })
                      : history.push('poa-approver', { distributorId: values.distributorId })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
              </Hidden>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: '#1C2D47',
                  pl: { xs: 3, sm: 0 },
                }}>
                {poaApproverId ? 'POA Approver' : 'Onboarding POA Approver'}
              </Typography>
            </Box>
            {loading ? (
              <LinearProgress />
            ) : (
              <CommonFormForCompanyDistributors
                values={values}
                onCancel={() =>
                  poaApproverId
                    ? history.push('poa-approver-details', {
                        poaApproverId: values.id,
                        distributorId: values.distributorId,
                      })
                    : history.push('poa-approver', { distributorId: values.distributorId })
                }
              />
            )}
          </Box>
        )}
      </Formik>
      <UserMgmtSuccessDialog
        open={Boolean(successMessage)}
        message={successMessage || ''}
        onGoToUserManagement={() =>
          history.push('poa-approver', { distributorId: successDistributorId })
        }
      />
    </>
  );
}
